// Single source of truth for the 5 MyCraftz showcase books.
// Maps the books visible in the iCraftz library to their MyCraftz slug + the
// "If You Remember One Thing..." pull-quote shown inside their book modal.
// The CraftPrint blueprint itself (sutra, nimitta, kriya, etc.) lives on the
// backend (/api/mycraftz/showcase/{slug}) and is fetched on demand.

export const MYCRAFTZ_SHOWCASE = {
  "Atomic Habits": {
    slug: "atomic-habits",
    rememberOneThing:
      "Your identity shapes your habits — and your habits, repeated, reshape your identity.",
    ideaName: "Identity-Based Habit",
  },
  "Deep Work": {
    slug: "deep-work",
    rememberOneThing:
      "Your ability to focus, uninterrupted, is the most valuable skill of this century.",
    ideaName: "90-Minute Focus Block",
  },
  "The Psychology of Money": {
    slug: "psychology-of-money",
    rememberOneThing:
      "Behaviour beats brilliance — the quiet patience of years compounds louder than any single insight.",
    ideaName: "48-Hour Spending Rule",
  },
  "Think and Grow Rich": {
    slug: "think-and-grow-rich",
    rememberOneThing:
      "A definite purpose — written and rehearsed daily — is the seed of every great life.",
    ideaName: "Purpose Statement",
  },
  "Man's Search for Meaning": {
    slug: "mans-search-for-meaning",
    rememberOneThing:
      "Those who have a 'why' to live can bear almost any 'how'.",
    ideaName: "Meaning Journal",
  },
};

export const SHOWCASE_TITLES = Object.keys(MYCRAFTZ_SHOWCASE);

// Slug → numeric book id (matches backend SHOWCASE_DEMO_BOOKS and the
// iCraftz library ids). Used to bridge logged-in users from the old
// /mycraftz installed grid onto the spec-compliant /sadhana + /siddhi pages.
export const SHOWCASE_SLUG_TO_BOOK_ID = {
  "atomic-habits": 4,
  "deep-work": 18,
  "psychology-of-money": 7,
  "think-and-grow-rich": 5,
  "mans-search-for-meaning": 50,
};

export function bookIdForSlug(slug) {
  return SHOWCASE_SLUG_TO_BOOK_ID[slug] ?? null;
}

export function getShowcaseFor(book) {
  if (!book) return null;
  return MYCRAFTZ_SHOWCASE[book.title] || null;
}
